import React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { useAmplitude } from 'shared/hooks/use-amplitude';

import useProductQueryParams from 'hooks/use-product-query-params';

const VARIANT_STYLES_MAP = {
  default: css`
    ${({ theme, selected }) => `
      background: ${
        selected
          ? `var(--dcm-color-surface-hover, ${theme.colors.grey[35]})`
          : `var(--dcm-filter-search-bg, var(--dcm-color-surface, ${theme.colors.white}))`
      };
      border: ${selected ? `none` : `solid 1px var(--dcm-filter-border-color, ${theme.colors.blueGrey[80]})`};
      color: ${selected ? theme.colors.white : `var(--dcm-filter-text-color, ${theme.colors.grey[25]})`};
    `}
  `,
  light: css`
    ${({ theme, selected }) => `
      background: var(--dcm-filter-search-bg, var(--dcm-color-surface, ${theme.colors.white}));
      border: ${
        selected
          ? `solid 2px ${theme.customized.colors.buttonsLinks}`
          : `solid 1px var(--dcm-filter-border-color, ${theme.colors.grey[70]})`
      };
      color: ${
        selected ? theme.customized.colors.buttonsLinks : `var(--dcm-filter-text-color, ${theme.colors.primaryBlack})`
      };
    `}
  `,
};

export default function Weight({ variant = `default`, selected = false, weightForQueryParams, displayWeight }) {
  const { defaults, setQueryParams } = useProductQueryParams();
  const amplitude = useAmplitude();

  const handleClick = () => {
    const newWeight = selected ? defaults.weight : weightForQueryParams;

    if (newWeight) {
      amplitude.log(`Weight Filter`, {
        description: `User clicks/taps on Weight Filter while shopping`,
        weightSelected: newWeight,
      });
    }

    setQueryParams({
      weight: newWeight,
      page: defaults.page,
    });
  };

  return (
    <Button type='button' selected={selected} onClick={handleClick} variantStyles={VARIANT_STYLES_MAP[variant]}>
      {_.trimEnd(displayWeight, 'C')}
    </Button>
  );
}

const Button = styled.button`
  align-items: center;
  border-radius: var(--dct--customized-radius-sm);
  cursor: pointer;
  display: flex;
  font-size: 12px;
  font-weight: ${({ selected }) => (selected ? `bold` : `normal`)};
  height: 34px;
  justify-content: center;
  line-height: 2.5;
  margin-top: 1px;
  outline: none;
  padding: 0;
  font-family: inherit;

  &&& {
    ${({ variantStyles }) => variantStyles}
  }
`;
